import { connect } from 'react-redux'

import { colors } from '@piconetworks/functions'

import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'
import xFrame from 'common/xFrame'
import { withRouter } from 'common/components/MenuRouterAdapter'

import Overlay from 'common/components/Overlay'

const mapStateToProps = (state, { router }) => {
    const linkColor = Loader.selectors.linkColor(state)
    const scopedLoader = state.loader.user || state.loader.guest
    const { cover_photo: coverPhoto = null } = scopedLoader?.publisher || {}

    const popupId = Wizard.selectors.thisWizardPopupId({
        state,
        router,
    })

    const popup = Loader.selectors.popupGetPopupById(state, popupId)

    return {
        linkColor,
        contrastColor: colors.getContrastColor(linkColor),
        coverPhoto: popup?.cover_image || coverPhoto,
        logoColor: scopedLoader?.publisher?.logoColor,
    }
}

const mapDispatchToProps = (dispatch) => ({
    showLauncher: () => {
        xFrame.prompt.showLauncher({ dispatch })
    },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Overlay))
